import apiClient from "../../utils/apiClient.js";
import {
    DELETE_AUDIOBOOK,
    EDIT_AUDIOBOOK,
    GET_AUDIOBOOK_DETAILS,
    GET_AUDIOBOOK_DIALOGUES,
    GET_AUDIOBOOKS,
    MERGING_AUDIOBOOK,
    REGENERATE_ALL_VOICES,
    UPDATE_AUDIOBOOK_VOICE,
} from "../../ApiEndpoints.js";

export const getAudiobooks = ({ pageSize = 10, cursor = null } = {}) => {
    const queryParams = new URLSearchParams({
        pageSize,
        ...(cursor ? { lastDocId: cursor } : {}),
        sortBy: "createdAt",
        sortOrder: "desc",
    });

    return apiClient.get(`${GET_AUDIOBOOKS}?${queryParams}`);
};

export const getAudiobookDetails = (projectId) => (
    apiClient.get(`${GET_AUDIOBOOK_DETAILS}/${projectId}`)
);

export const deleteAudiobook = (projectId) => (
    apiClient.delete(`${DELETE_AUDIOBOOK}/${projectId}`)
);

export const editAudiobook = (payload) => apiClient.post(EDIT_AUDIOBOOK, payload);

export const getAudiobookDialogues = (projectId, config) => (
    apiClient.get(`${GET_AUDIOBOOK_DIALOGUES}/${projectId}`, config)
);

export const mergeAudiobook = (payload, config) => (
    apiClient.post(MERGING_AUDIOBOOK, payload, config)
);

export const updateAudiobookVoice = (payload) => (
    apiClient.post(UPDATE_AUDIOBOOK_VOICE, payload)
);

export const regenerateAllAudiobookVoices = (payload) => (
    apiClient.post(REGENERATE_ALL_VOICES, payload)
);
